<script>
  import API from '../Stores/API';
  import Trail from '../Components/Trail';
  import View from '../Stores/View';
  import {afterUpdate} from 'svelte';

  let context = '';
  let subscriptions_element;
  let subscriptions_flickity;
  let maintenances_element;
  let maintenances_flickity;

  function setSubscription(subscription) {
    View.setView('subscription', {subscription});
  }

  function setSubscriptions() {
    subscriptions_flickity = new Flickity(subscriptions_element, {
      cellAlign: 'center',
      imagesLoaded: true,
      pageDots: false,
      prevNextButtons: false,
      contain: true
    });
  }

  function setMaintenances() {
    maintenances_flickity = new Flickity(maintenances_element, {
      imagesLoaded: true,
      pageDots: false,
      wrapAround: true
    });

    maintenances_flickity.on('staticClick', (event, pointer, cellElement, cellIndex) => {
      const maintenance = $API.data.maintenances[cellIndex];
      View.setView('maintenance', {subscription: false, maintenance});
    });
  }

  afterUpdate(() => {
    if ($API.data) {
      if (!subscriptions_flickity && subscriptions_element && subscriptions_element.hasChildNodes())
        setSubscriptions();

      if (!maintenances_flickity && maintenances_element && maintenances_element.hasChildNodes())
        setMaintenances();
    }
  });
</script>

{#if $API.data}
  <Trail path="{[['Account']]}"/>
  <div class="bg-light">
    <section class="pt-6 bg-dark">
      <div class="container-lg">
        <div class="row justify-content-center">
          <div class="col-md-10 col-lg-8 text-center text-white">
            <h1 class="display-3 mb-4"><span class="text-underline-warning">Welkom {$API.data.user.name}</span>: Bij de Eeuwige Tuinen!</h1>
            <p class="fs-lg">Hier kun je het onderhoud van jouw abonnementen volgen en eventuele aanpassingen maken. Heb je hier hulp bij nodig? Dan kun je tijdens kantooruren bellen met <a class="eg-fancy text-primary-light" href="tel:0031850014241">085 - 001 4241</a></p>
            {#if $View.config.notice}
              <div class="alert alert-warning">{$View.config.notice}</div>
            {/if}
          </div>
        </div>
      </div>
    </section>
    <div class="position-relative">
      <div class="shape shape-fluid-x shape-bottom text-dark pb-15">
        <div class="shape-img pb-8 pb-md-11">
          <svg viewBox="0 0 100 50" preserveAspectRatio="none"><path d="M0 0h100v25H75L25 50H0z" fill="currentColor"/></svg>
        </div>
      </div>
    </div>
    <section class="position-relative pt-4">
      <div class="container-lg">
        <div class="row">
          <div class="col-12">
            <div bind:this="{subscriptions_element}" class="flickity-viewport-visible mx-n4">
              <div class="position-absolute col-12 px-4" style="max-width: 300px;">
                <div class="card card-sm rounded-top-start rounded-bottom-end lift">
                  <img class="card-img rounded-top-start" src="{context}/assets/img/eternal-gardens/blog/nagedachtenis-van-dierbaren-eren-wide-2.webp" alt="Plaatsen van Bloemen">
                  <div class="position-relative">
                    <div class="shape shape-fluid-x shape-top text-white">
                      <div class="shape-img pb-4">
                        <svg viewBox="0 0 100 50" preserveAspectRatio="none"><path d="M0 25h25L75 0h25v50H0z" fill="currentColor"/></svg>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <small class="mb-1 text-primary" style="text-transform: uppercase; font-size: .5em; font-weight: 600;">Jouw Gegevens</small>
                    <h3 class="mb-0 text-primary">{$API.data.user.name}</h3>
                    <small>{$API.data.user.email}</small>
                    <small>{$API.data.user.phone}</small>
                    <a class="btn btn-sm eg-btn-sm btn-primary mt-4" on:click="{event => { View.setView('profile') }}">Aanpassen</a>
                  </div>
                </div>
              </div>
              {#each $API.data.subscriptions as subscription}
                <div class="position-absolute col-12 px-4" style="max-width: 300px;">
                  <div class="card card-sm rounded-top-start rounded-bottom-end lift">
                    <img class="card-img rounded-top-start" src="{subscription.image || '/assets/img/eternal-gardens/blog/gids-voor-duurzame-grafversieringen-wide.webp'}" alt="{subscription.plot.departed.name}">
                    <div class="position-relative">
                      <div class="shape shape-fluid-x shape-top text-white">
                        <div class="shape-img pb-4">
                          <svg viewBox="0 0 100 50" preserveAspectRatio="none"><path d="M0 25h25L75 0h25v50H0z" fill="currentColor"/></svg>
                        </div>
                      </div>
                    </div>
                    <div class="card-body">
                      <h3 class="mb-2 text-secondary">{subscription.plot.departed.name}</h3>
                      <small>{subscription.plot.cemetery.city.name}</small><br/>
                      <small>{subscription.subscription_type_interval.subscription_type.name} Onderhoud</small><br/>
                      {#if subscription.maintenance_before}
                        <small class="text-secondary fw-bold">Gepland voor {subscription.maintenance_before}</small><br/>
                      {/if}
                      <a class="btn btn-sm eg-btn-sm btn-secondary mt-4" on:click="{event => setSubscription(subscription)}">Beheren</a>
                    </div>
                  </div>
                </div>
              {/each}
              <div class="position-absolute col-12 px-4" style="max-width: 300px;">
                <div class="card card-sm rounded-top-start rounded-bottom-end lift">
                  <img class="card-img rounded-top-start" src="{context}/assets/img/eternal-gardens/diensten/plaatsen-van-bloemen.webp" alt="Graf Toevoegen?">
                  <div class="position-relative">
                    <div class="shape shape-fluid-x shape-top text-white">
                      <div class="shape-img pb-4">
                        <svg viewBox="0 0 100 50" preserveAspectRatio="none"><path d="M0 25h25L75 0h25v50H0z" fill="currentColor"/></svg>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <h3 class="mb-2 text-primary-light">Graf Toevoegen?</h3>
                    <small>Wil je een extra graf schoon laten maken? Voeg dan een nieuw abonnement toe.</small>
                    <a class="btn btn-sm eg-btn-sm btn-primary-light mt-4" href="{context}/aanmelden">Toevoegen</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    {#if $API.data.maintenances?.length}
      <section class="mt-8 pb-4">
        <div class="container-lg">
          <div class="row justify-content-center">
            <div class="col-md-10 col-lg-10 text-center">
              <hr class="hr-sm bg-warning mx-auto mt-1 mb-6">
              <h4 class="display-4 mb-8 text-primary">
                De Zorg die we Bieden: het Resultaat van <span class="text-primary-light text-underline-primary-light">Zorgvuldig Onderhoud.</span>
              </h4>
            </div>
          </div>
        </div>
        <div bind:this="{maintenances_element}" class="flickity-items-fade">
          {#each $API.data.maintenances as maintenance}
            {#if maintenance.after}
              <div style="width: calc(100% - 2rem); max-width: 380px;">
                <img class="img-fluid rounded" src="{maintenance.after}" alt="{maintenance.deceased}">
                <div class="flickity-hidden py-6 text-center">
                  <h6 class="text-uppercase text-primary-light">
                    {maintenance.deceased}
                  </h6>
                  <p class="fs-sm text-center mb-0">
                    <b class="text-capitalize">{maintenance.date}</b><br/>
                    {maintenance.level || 'Schoonvegen'}
                  </p>
                </div>
              </div>
            {/if}
          {/each}
        </div>
      </section>
    {:else}
      <section class="my-6">
        <div class="container-lg">
          <div class="row justify-content-center">
            <div class="col-md-10 col-lg-10 text-center">
              <h4 class="display-4 mb-8 text-primary">
                Binnenkort vindt Je hier het Resultaat van ons <span class="text-primary-light text-underline-primary-light">Zorgvuldig Onderhoud.</span>
              </h4>
            </div>
          </div>
        </div>
      </section>
    {/if}
  </div>
{/if}